import NumberFormat from "react-number-format";
import { FinancialRequestInterface } from "../../../../../Applications/CCLFForm/type";
import { CurrencyFormatDisplay } from "../../../../../UI/NumberFormatDisplay/CurrencyFormatDisplay";

export default function CCLFApplicationLoan({
  financialRequest,
}: {
  financialRequest: FinancialRequestInterface;
}) {
  return (
    <>
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="py-5">
            <div className="px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal">
              <h2
                id="applicant-information-title"
                className="m-0 text-lg leading-6 font-medium text-primaryColor-normal"
              >
                Financial Request
              </h2>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                Details of an financial request.
              </p>
            </div>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6 space-y-5">
            {financialRequest && (
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1 space-y-2">
                  <div>
                    <dt className="text-sm font-medium text-gray-500">
                      Loan Request
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      <CurrencyFormatDisplay
                        value={financialRequest.loanRequest.loanRequestAmount}
                        prefix="$"
                      />
                    </dd>
                  </div>
                  <div>
                    <dt className="text-sm font-medium text-gray-500">
                      Max # of units at any given time
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      <NumberFormat
                        value={financialRequest.loanRequest.maxUnits}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                    </dd>
                  </div>
                </div>

                <div className="col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Project Address
                  </dt>
                  <dd>{financialRequest.projectInfo.address}</dd>
                  <dd>{financialRequest.projectInfo.city}</dd>
                  <dd>
                    {financialRequest.projectInfo.state},
                    {financialRequest.projectInfo.zipCode}
                  </dd>
                </div>
                <div>
                  <dt className="text-sm font-medium text-gray-500">Sources</dt>
                  <dd className="flex flex-col">
                    <span>
                      Borrower Equity (
                      <CurrencyFormatDisplay
                        value={
                          financialRequest.projectInfo.sources.borrowerEquity
                        }
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Debt (
                      <CurrencyFormatDisplay
                        value={financialRequest.projectInfo.sources.debt}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Total Sources (
                      <CurrencyFormatDisplay
                        value={
                          financialRequest.projectInfo.sources.borrowerEquity +
                          financialRequest.projectInfo.sources.debt
                        }
                        prefix="$"
                      />
                      )
                    </span>
                  </dd>
                </div>
                <div>
                  <dt className="text-sm font-medium text-gray-500">Uses</dt>
                  <dd className="flex flex-col">
                    <span>
                      Average Acquisition (
                      <CurrencyFormatDisplay
                        value={
                          financialRequest.projectInfo.uses.averageAcquisition
                        }
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Average Rehabilitation (
                      <CurrencyFormatDisplay
                        value={
                          financialRequest.projectInfo.uses
                            .averageRehabilitation
                        }
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      10 % Contingency (
                      <CurrencyFormatDisplay
                        value={
                          financialRequest.projectInfo.uses.tenPContingency
                        }
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Soft Costs (
                      <CurrencyFormatDisplay
                        value={financialRequest.projectInfo.uses.softCost}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Closing Costs (
                      <CurrencyFormatDisplay
                        value={financialRequest.projectInfo.uses.closingCost}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Total Uses (
                      <CurrencyFormatDisplay
                        value={
                          financialRequest.projectInfo.uses.averageAcquisition +
                          financialRequest.projectInfo.uses
                            .averageRehabilitation +
                          financialRequest.projectInfo.uses.closingCost +
                          financialRequest.projectInfo.uses.tenPContingency +
                          financialRequest.projectInfo.uses.softCost +
                          financialRequest.projectInfo.uses.closingCost
                        }
                        prefix="$"
                      />
                      )
                    </span>
                  </dd>
                </div>
              </dl>
            )}
            {/* {loan && (
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1 space-y-2">
                  <div>
                    <dt className="text-sm font-medium text-gray-500">
                      Loan Request
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      <CurrencyFormatDisplay
                        value={loan.loanRequest.loanAmount}
                        prefix="$"
                      />
                    </dd>
                  </div>
                  <div>
                    <dt className="text-sm font-medium text-gray-500">
                      Max # of units at any given time
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      <NumberFormat
                        value={loan.loanRequest.maxUnits}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                    </dd>
                  </div>
                </div>
                <div>
                  <dt className="text-sm font-medium text-gray-500">Sources</dt>
                  <dd className="flex flex-col">
                    <span>
                      Borrower Equity (
                      <CurrencyFormatDisplay
                        value={loan.sources.borrowerEquity}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Debt (
                      <CurrencyFormatDisplay
                        value={loan.sources.debt}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Total Sources (
                      <CurrencyFormatDisplay
                        value={loan.sources.borrowerEquity + loan.sources.debt}
                        prefix="$"
                      />
                      )
                    </span>
                  </dd>
                </div>
                <div>
                  <dt className="text-sm font-medium text-gray-500">Uses</dt>
                  <dd className="flex flex-col">
                    <span>
                      Average Aquisition (
                      <CurrencyFormatDisplay
                        value={loan.uses.averageAcquisition}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Average Rehabilitation (
                      <CurrencyFormatDisplay
                        value={loan.uses.averageRehabilitation}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      10 % Contigency (
                      <CurrencyFormatDisplay
                        value={loan.uses.tenPContingency}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Soft Costs (
                      <CurrencyFormatDisplay
                        value={loan.uses.softCost}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Closing Costs (
                      <CurrencyFormatDisplay
                        value={loan.uses.closingCost}
                        prefix="$"
                      />
                      )
                    </span>
                    <span>
                      Total Uses (
                      <CurrencyFormatDisplay
                        value={
                          loan.uses.averageAcquisition +
                          loan.uses.averageRehabilitation +
                          loan.uses.closingCost +
                          loan.uses.tenPContingency +
                          loan.uses.softCost +
                          loan.uses.closingCost
                        }
                        prefix="$"
                      />
                      )
                    </span>
                  </dd>
                </div>
              </dl>
            )} */}
          </div>
        </div>
      </section>
    </>
  );
}
